import { useContext, createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import ApiService from "../helpers/Services.js";
import storage from "../helpers/storage.js";
import Config from "../Config.js";
import { useFilterContext } from "../context/FilterContext";

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState({
    email: null,
    isAdmin: false,
    roles: [],
  });
  const [loading, setLoading] = useState(true);

  const { clearFilters } = useFilterContext(); // Ensure FilterProvider is wrapping this context

  const checkUserAccess = async () => {
    let token = storage.getToken();
    if (!token) {
      setLoading(false);
      return;
    }

    const { email } = jwtDecode(token);
    try {
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      const roles = await ApiService.post(
        "user-management",
        {
          action: "describeUser",
          payload: {
            vendor: "Vanguard",
            email: email,
          },
        },
        headers
      );

      const hasAdminRole = roles.some(
        (role) => role.rolename === "Admin" && role.status === "Active"
      );
      const roleNames = Array.from(
        new Set(
          roles
            .filter((r) => r.rolename && r.status === "Active")
            .map((r) => r.rolename)
        )
      );

      setUser({
        email,
        isAdmin: hasAdminRole,
        roles: roleNames,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  console.log({ user });

  const handlerLogout = () => {
    clearFilters(); // Clear filters during logout
    storage.clearToken();
    storage.clearFileName();
    storage.clearUserName();
    const logoutUrl = Config.LogoutUrl;
    window.location.href = logoutUrl;
  };

  useEffect(() => {
    checkUserAccess();
  }, []);

  return (
    <AuthContext.Provider value={{ handlerLogout, user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const UserAuth = () => {
  return useContext(AuthContext);
};
